import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import login from './modules/login'
import auth from './modules/auth'
import role from './modules/role'
import dept from './modules/dept'
import user from './modules/user'
import device from './modules/device'
import factory from './modules/factory'
import workshop from './modules/workshop'
import scene from './modules/scene'
import oss from './modules/oss'
import monitorData from './modules/monitorData'
import permission from './modules/permission'
import log from './modules/log'
import dict from './modules/dict'
import home from './modules/home'
Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
      app,
      login,
      auth,
      role,
      dept,
      user,
      device,
      factory,
      workshop,
      scene,
      oss,
      monitorData,
      permission,
      log,
      dict,
      home
    }
  })
